import React, { createContext, useState, useMemo } from "react";
import { CommonPathWay } from "./CommonPathWay";
import InfoBar from "./InfoBar/InfoBar";
import { Helmet } from "react-helmet";
import ExperianLogo from "../Assets/NavBar_SideBar/experian_logo.png";
export const UserContext = createContext();
const UserProvider = ({ children }) => {
  const [globalcredit, setGlobalcredit] = useState(0);
  const [requiringCredits, setRequiringCredits] = useState(0);
  const [globalimage, setGlobalimage] = useState("");
  const [globalname, setGlobalname] = useState("");
  const [globalrolename, setGlobalrolename] = useState("");
  const [creditAvailability, setCreditAvailabilty] = useState(false);
  const [creditDebitedPopup, setCreditDebitedPopup] = useState(false);
  const [debitingCreditCount, setDebitingCreditCount] = useState(false);
  const [globalcustomerID, setGlobalcustomerID] = useState("");
  const [globalEmail, setGlobalEmail] = useState("");
  const [globalStatus, setGlobalStatus] = useState("");
  const [rolePages, setRolePages] = useState([]);
  const [customerId, setCustomerId] = useState(" ");
  const [otpVerified, setOtpVerified] = useState();
  const [teamId, setTeamId] = useState("");
  const configId = "676e49594cc28b59e0e9496a";
  const [creditDebitingConfiguration, setCreditDebitingConfiguration] =
    useState({
      download: {
        freeUserCreditValue: 1,
        creditValue: 1,
      },
      findICP: {
        creditValue: 1,
        freeUserCreditValue: 1,
      },
      findPeople: {
        creditValue: 1,
        freeUserCreditValue: 1,
      },
      findEmail: {
        creditValue: 1,
        freeUserCreditValue: 1,
      },
      composeEmail: {
        creditValue: 1,
        freeUserCreditValue: 1,
      },
      sendEmail: {
        creditValue: 1,
        freeUserCreditValue: 1,
      },
      addColumn: {
        creditValue: 1,
        freeUserCreditValue: 1,
      },
      replayCall: {
        creditValue: 1,
        freeUserCreditValue: 1,
      },
      customData: {
        creditValue: 1,
        freeUserCreditValue: 1,
      },
    });
  const [companyDetails, setCompanyDetails] = useState({
    title: "",
    companyName: "",
    imgURL: "",
    logoURL: "",
    id: "",
    loaderURL: "",
    description: "",
  });
  const updateCredit = async (
    debitingCreditCount,
    name,
    useCaseType,
    creditType,
    creditDetails
  ) => {
    try {
      const response = await CommonPathWay(
        "/v1/updateCredit",
        "POST",
        {},
        {
          isNewPlan: false,
          credit: debitingCreditCount,
          debited: creditDetails ?? false,
        }
      );
      if (response?.status === 200) {
        await saveCreditTracking(
          user?.userId,
          name,
          useCaseType,
          debitingCreditCount
        );
        setDebitingCreditCount(
          creditType === "customData" || creditType === "customOrder"
            ? debitingCreditCount
            : debitingCreditCount *
            creditDebitingConfiguration[creditType]?.creditValue
        );
        if (debitingCreditCount > 0) {
          setCreditDebitedPopup(true);
        }
        return response;
      }
    } catch (e) {
      return {};
    }
  };
  const creditAvailabilityVerification = (requiredCredit) => {
    if (requiredCredit > globalcredit) {
      setCreditAvailabilty(true);
    }
    setRequiringCredits(requiredCredit);
    return requiredCredit > globalcredit;
  };
  const saveCreditTracking = async (userId, filename, useCaseType, count) => {
    let description;

    if (useCaseType === "Single") {
      description = `Validation of single email (Email: ${filename})`;
    } else if (useCaseType === "Bulk") {
      description = `Validation of ${count} emails (Email: ${filename})`;
    } else {
      description = filename;
    }

    try {
      const response = await CommonPathWay(
        "/v1/saveCreditTracking",
        "POST",
        {},
        {
          userId: userId,
          changes: `-${count}`,
          description: description,
          emailAddress: globalEmail,
          date: new Date(),
          type: "debit",
        }
      );
      return response;
    } catch (e) { }
  };

  return (
    <>
      <Helmet>
        <title>Experian</title>
        <link rel="icon" href={ExperianLogo} type="image/png" />
      </Helmet>
      <UserContext.Provider
        value={useMemo(
          () => ({
            globalcredit,
            setGlobalcredit,
            globalimage,
            setGlobalimage,
            globalname,
            setGlobalname,
            globalrolename,
            customerId,
            setGlobalrolename,
            globalcustomerID,
            setGlobalcustomerID,
            otpVerified,
            setOtpVerified,
            globalEmail,
            setGlobalEmail,
            globalStatus,
            setGlobalStatus,
            rolePages,
            setRolePages,
            teamId,
            setTeamId,
            updateCredit,
            creditAvailability,
            setCreditAvailabilty,
            debitingCreditCount,
            setDebitingCreditCount,
            creditDebitedPopup,
            setCreditDebitedPopup,
            creditAvailabilityVerification,
            configId,
            creditDebitingConfiguration,
            setCreditDebitingConfiguration,
            setCompanyDetails,
            companyDetails,
            requiringCredits,
            setRequiringCredits,
          }),
          [
            globalcredit,
            globalimage,
            globalname,
            globalrolename,
            customerId,
            globalcustomerID,
            otpVerified,
            globalEmail,
            globalStatus,
            rolePages,
            teamId,
            updateCredit,
            creditAvailability,
            debitingCreditCount,
            creditDebitedPopup,
            creditAvailabilityVerification,
            configId,
            creditDebitingConfiguration,
            companyDetails,
            requiringCredits,
          ]
        )}
      >
        {children}
      </UserContext.Provider>
      {creditDebitedPopup && (
        <InfoBar
          Information={`${debitingCreditCount} credit debited successfully`}
          flag={true}
          setPopupState={setCreditDebitedPopup}
          popupState={creditDebitedPopup}
        />
      )}
    </>
  );
};
export default UserProvider;
